import React from 'react';
import { Typography, Box } from '@mui/material';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import SectionCard from '../ui/SectionCard';
import { STATUS_LABELS, getStatusHex } from '../../constants/status';
import { formatDateTime } from '../../utils/format';

// timeline แนวตั้ง — ลำดับเวลามีความหมายจริง (ประวัติเปลี่ยนสถานะ) จุดสีตามสถานะปลายทาง
// ของแต่ละแถวช่วยไล่สายตาเห็นเส้นทางของโครงการได้เร็วโดยไม่ต้องอ่านทุกบรรทัด
export function StatusHistoryList({ history }) {
  const items = (history || []).slice().reverse();

  return (
    <SectionCard icon={<HistoryOutlinedIcon />} title="ประวัติการเปลี่ยนสถานะ" accentColor="grey.500">
      {items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">ยังไม่มีประวัติ</Typography>
      ) : (
        <Box>
          {items.map((h, idx) => (
            <Box key={h.id} sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 12, flexShrink: 0 }}>
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    flexShrink: 0,
                    mt: 0.6,
                    bgcolor: getStatusHex(h.to_status),
                  }}
                />
                {idx < items.length - 1 && (
                  <Box sx={{ width: '1px', flex: 1, bgcolor: 'divider', my: 0.5 }} />
                )}
              </Box>
              <Box sx={{ pb: idx < items.length - 1 ? 2 : 0 }}>
                <Typography variant="body2">
                  {h.from_status && (
                    <Typography component="span" variant="body2" color="text.secondary">
                      {STATUS_LABELS[h.from_status] || h.from_status}{' → '}
                    </Typography>
                  )}
                  <Typography component="span" variant="body2" fontWeight={700}>
                    {STATUS_LABELS[h.to_status] || h.to_status}
                  </Typography>
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  {formatDateTime(h.changed_at)}
                </Typography>
                {h.note && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{h.note}</Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </SectionCard>
  );
}

export default StatusHistoryList;
